import script from "./HTwbActKitHome.vue?vue&type=script&setup=true&lang=js"
export * from "./HTwbActKitHome.vue?vue&type=script&setup=true&lang=js"

import "./HTwbActKitHome.vue?vue&type=style&index=0&id=572d17d4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-572d17d4"]])

export default __exports__